import React from 'react'
import { Box } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { CustomTab } from 'components';

const ProductAssignmentTabScreen = () => {
  const navigate = useNavigate();

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Proveedores",
            route: '/asignacion-productos/proveedores',
            onChange: () => navigate('proveedores/tae'),
            content: <Outlet />
          },
          {
            name: "Comercios",
            route: '/asignacion-productos/comercios',
            onChange: () => navigate('comercios/tae'),
            content: <Outlet />
          },
        ]}
      />
    </Box>
  )
}

export default ProductAssignmentTabScreen